import {
  Box,
  Checkbox,
  FormControlLabel,
  Grid,
  Link,
  MenuItem,
  Select,
  SelectChangeEvent,
  Stack,
  styled,
  Theme,
  Typography,
  useMediaQuery
} from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import {
  AppConfig,
  BulkPdfExportPassword,
  NameUtils,
  storageUtils
} from '@oh-vcp/components-common';
import { DisplayMobile, EconsultActionButton, useNotifierContext } from '@oh-vcp/components-ui';
import { useAuth, useGetBulkPdfPassword } from '@oh-vcp/components-web';
import dayjs, { Dayjs } from 'dayjs';
import moment from 'moment';
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useUserDelegates from '../../api/useUserDelegates';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';
import CaseService from '@oh-vcp/components-web/src/services/caseService';

const ReportDropDown = styled(Select<string>)(({ theme }) => ({
  marginLeft: 5,
  color: theme.palette.primary.main,
  minWidth: 100,
  marginTop: 1,
  '& .MuiSvgIcon-root': {
    top: 0
  }
}));

const ReportMenuItem = styled(MenuItem)(({ theme }) => ({
  color: theme.palette.primary.main
}));

const ReportFormDateField = styled(DesktopDatePicker)({
  '& .MuiInputBase-input': {
    height: 10,
    fontSize: '16px'
  },
  '& .MuiInputBase-input::placeholder': {
    fontSize: '16px'
  }
});

const EconsultReportsView = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user } = useAuth();
  const { addNotification, removeAllErrorNotifications } = useNotifierContext();
  const [selectedDelegatorId, setSelectedDelgatorId] = useState<string | undefined>('0');
  const allowedReportAsTypes = ['REFERRER', 'OTHER_TYPE1', 'OTHER_TYPE2', 'SPECIALIST', 'TRIAGE'];
  const [reportAsType, setReportAsType] = useState<string>('REFERRER');
  const [consentPhi, setConsentPhi] = useState<boolean>(false);
  const [consentResponsibility, setConsentResponsibility] = useState<boolean>(false);
  const [consentShared, setConsentShared] = useState<boolean>(false);
  const [reportFormat, setReportFormat] = useState<string>('CSV');
  const [startDate, setStartDate] = useState<string | undefined>(
    moment().subtract(7, 'days').format('YYYY-MM-DD')
  );
  const [endDate, setEndDate] = useState<string | undefined>(moment().format('YYYY-MM-DD'));

  const [delegators, setDelegators] = useState<any[]>([]);
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));
  const { data: delegatorsList } = useUserDelegates(user?.userid);
  const [startDateVal, setStartDateVal] = React.useState<Dayjs | null>(dayjs(''));
  const [endDateVal, setEndDateVal] = React.useState<Dayjs | null>(dayjs(''));
  const [isDownloadingReport, setIsDownloadingReport] = useState<boolean>(false);
  const [isDateValid, setIsDateValid] = useState<boolean>(true);
  const [isDelegatorPDFExport, setIsDelegatorPDFExport] = useState<boolean>(false);
  const [pdfFilesNumber, setPdfFilesNumber] = useState<any | null>(null);

  const isGenerateBtnDisabled =
    isDownloadingReport || !isDateValid ||
    (reportFormat === 'PDF' &&
      (!consentResponsibility ||
        !consentShared ||
        !consentPhi ||
        (delegators && delegators.length > 1 && selectedDelegatorId?.toString() === '0')));

  const currentDate = () => {
    const today = new Date();
    const month = today.getMonth() + 1;
    const year = today.getFullYear();
    const date = today.getDate();
    return `${year}-${month}-${date}`;
  };
  const findSelectedDelegator = () => {
    if (!delegators || delegators.length === 0) {
      return null;
    }
    console.log(`delegators: ${JSON.stringify(delegators)}`);
    const dele = delegators.find((userId) => userId === selectedDelegatorId);
    console.log('dele found: ');
    return dele;
  };

  const [maxStartDate, setMaxStartDate] = useState<string | undefined>(
    moment().subtract(0, 'days').format('YYYY-MM-DD')
  );
  const isReportDateValid = (dateStrStart: string, dateStrEnd: string) => {
    if (!dateStrStart || dateStrStart === '' || !dateStrEnd || dateStrEnd === '') {
      return false;
    }
    const today = new Date();
    const month = today.getMonth() + 1;
    const year = today.getFullYear();
    const date = today.getDate();
    const curDate = `${year}-${month}-${date}`;
    if (dayjs(dateStrStart).isAfter(dayjs(curDate)) || dayjs(dateStrEnd).isAfter(dayjs(curDate))) {
      return false;
    }
    if (dayjs(dateStrStart).isAfter(dayjs(dateStrEnd))) {
      return false;
    }
    return true;
  };
  const isAnyDelegatorPdfExport = () => {
    if (!delegators || delegators.length === 0 || !selectedDelegatorId) {
      return false;
    }
    let delegatorEconPerm = false;
    if (selectedDelegatorId !== '0') {
      const selDele = findSelectedDelegator();
      console.log(`delegators: ${JSON.stringify(selDele)}`);
      if (selDele &&
        (selDele.otnServices?.indexOf('case_create') !== -1 ||
        selDele.otnServices?.indexOf('case_consult_on') !== -1)
      ) {
        delegatorEconPerm = true;
      }
    }
    console.log('isAnyDelegatorPdfExport return: ', delegatorEconPerm);
    return delegatorEconPerm;
  };

  const currentUserHasPdfExportPermission = useMemo(() => {
    console.log(JSON.stringify(user?.roles))
    return (
      user?.groups?.includes('case_consult_on') ||
      user?.groups?.includes('case_create') ||
      user?.roles?.econCaseConsultOn ||
      user?.roles?.econCaseCreate
    );
  }, [user]);

  const isPilotBulkPdfExport = (!delegators || delegators.length === 0) ? currentUserHasPdfExportPermission || false : isDelegatorPDFExport || false;
  console.log('initial, isPilotBulkPdfExport: ', isPilotBulkPdfExport);
  useEffect(() => {
    setIsDelegatorPDFExport(isAnyDelegatorPdfExport());
    console.log('useEffect change, isPilotBulkPdfExport: ', isPilotBulkPdfExport);
  }, [delegators, selectedDelegatorId]);

  useEffect(() => {
    if (delegatorsList && delegatorsList.length > 0) {
      let delegatorsArray = [];
      delegatorsArray.push({
        userId: 0,
        firstName: reportFormat === 'PDF' ? 'Select one' : 'All',
        lastName: ''
      });
      delegatorsArray = delegatorsArray.concat(delegatorsList);
      setDelegators(delegatorsArray);
    } else {
      setDelegators([]);
    }
  }, [delegatorsList, reportFormat]);

  useEffect(() => {
    setStartDateVal(dayjs(startDate));
    setEndDateVal(dayjs(endDate));
    setIsDateValid(isReportDateValid(startDate || '', endDate || ''));
  }, [startDate, endDate]);

  const handleReportFormatChanged = (event: SelectChangeEvent<string>) => {
    const value = event.target.value;
    setReportFormat(value);
    setConsentPhi(false);
    setConsentResponsibility(false);
    setConsentShared(false);
    if (value !== 'PDF') {
      setIsDownloadingReport(false);
    }
  };

  const handleReportAsTypeChanged = (event: SelectChangeEvent<string>) => {
    const value = event.target.value;
    if (allowedReportAsTypes.includes(value)) {
      setReportAsType(value);
    } else {
      // Handle invalid value, e.g., set a default value or show an error
      setReportAsType('REFERRER');
    }
    setIsDownloadingReport(false);
  };
  const handleDelegatorChanged = (event: SelectChangeEvent<string>) => {
    setSelectedDelgatorId(event.target.value);
    setIsDelegatorPDFExport(isAnyDelegatorPdfExport());
    console.log('handleDelegatorChanged, isPilotBulkPdfExport: ', isPilotBulkPdfExport);
    setIsDownloadingReport(false);
  };

  const downloadReportFile = (format: string) => {
    if (format) {
      const token = storageUtils.getUserToken();
      let url = AppConfig.apiHost;
      if (format === 'PDF') {
        url += 'cases/export/pdf/bulk';
      } else {
        url += 'cases/activity/export';
      }
      url += `?api_access_token=${token}&mode=${reportAsType}&startDate=${startDate}&endDate=${endDate}`;
      if (selectedDelegatorId && selectedDelegatorId !== '0') {
        url += '&delegatorId=' + encodeURIComponent(selectedDelegatorId);
      }
      window.location.href = url;
      if (format === 'PDF') {
        const delay =
          pdfFilesNumber && pdfFilesNumber.bulkPdfEntriesNumber
            ? Math.floor(pdfFilesNumber.bulkPdfEntriesNumber * 0.144) * 1000
            : 20000;
        console.log('Calculated delay : ', delay, pdfFilesNumber?.bulkPdfEntriesNumber);
        setTimeout(() => {
          setIsDownloadingReport(false);
        }, delay);
      }
    }
  };

  const { refetch: refetchBulkPdfPassword } = useGetBulkPdfPassword(selectedDelegatorId);

  const exportReport = async () => {
    removeAllErrorNotifications();
    if (reportFormat === 'PDF') {
      setIsDownloadingReport(true);
      let entriesNumber = null;
      try {
        entriesNumber = await CaseService.getBulkReportEentriesnumber(
          reportAsType,
          startDate || '',
          endDate || '',
          selectedDelegatorId || ''
        );
      } catch (error: any) {
        console.error('Error getBulkReportEentriesnumber: ' + error);
      }
      console.log('entriesNumber: ', entriesNumber ? JSON.stringify(entriesNumber) : '');
      if (entriesNumber?.bulkPdfEntriesNumber && entriesNumber.bulkPdfEntriesNumber > 1200) {
        setIsDownloadingReport(false);
        addNotification({
          type: 'error',
          message: t('Case.reports.FilesExceedWarning')
        });
        return;
      }
      setPdfFilesNumber(entriesNumber);
      const bulkPasswordResponse = await refetchBulkPdfPassword();
      const bulkPassword = bulkPasswordResponse?.data;
      if (bulkPassword?.bulkExportPassword && bulkPassword.bulkExportPassword.length > 0) {
        downloadReportFile('PDF');
      } else {
        setIsDownloadingReport(false);
        addNotification({
          type: 'error',
          message: t('Case.reports.permissionsWarning')
        });
      }
    } else {
      downloadReportFile(reportFormat);
    }
  };

  const handleGoBack = () => {
    setIsDownloadingReport(false);
    navigate('/');
  };
  return (
    <Stack p={3}>
      <Grid container>
        <DisplayMobile>
          <Box mt={2}>
            <ArrowBackIcon onClick={handleGoBack} />
          </Box>
        </DisplayMobile>
        <Grid item xs={12}>
          <Stack direction="row" mb={2}>
            <Typography variant="body1" color="base.grey3" pt={0.5}>
              {t('Case.reports.pleaseSelectReportType')}
            </Typography>
            <ReportDropDown
              disableUnderline
              variant="standard"
              value={reportFormat}
              onChange={handleReportFormatChanged}>
              <ReportMenuItem value="CSV">
                <Typography variant="body1">CSV</Typography>
              </ReportMenuItem>
              {isPilotBulkPdfExport && (
                <ReportMenuItem value="PDF">
                  <Typography variant="body1">PDF</Typography>
                </ReportMenuItem>
              )}
            </ReportDropDown>
          </Stack>
          {delegators && delegators.length > 1 && (
            <Stack direction="row">
              <Typography variant="body1" color="base.grey3" pt={0.5} mr={0.5}>
                {t('Case.reports.caseReportsOnBehalfOf')}
              </Typography>
              <ReportDropDown
                disableUnderline
                variant="standard"
                value={selectedDelegatorId}
                onChange={handleDelegatorChanged}>
                {delegators
                  .sort((a: any, b: any) => {
                    if (a.userId === 0 && b.userId !== 0) return -1;
                    if (a.userId !== 0 && b.userId === 0) return 1;
                    if (a.firstName < b.firstName) return -1;
                    if (a.firstName > b.firstName) return 1;
                    return 0;
                  })
                  .map((d: any) => (
                    <ReportMenuItem value={d?.userId}>
                      <Typography variant="body1">
                        {NameUtils.makeName(
                          d?.lastName,
                          d?.firstName,
                          d?.salutation,
                          d?.specialty,
                          null,
                          null
                        )}
                      </Typography>
                    </ReportMenuItem>
                  ))}
              </ReportDropDown>
            </Stack>
          )}
          <Stack direction="row" mt={2}>
            <Typography variant="body1" color="base.grey3" pt={0.5}>
              {t('Case.reports.caseReportsAs')}
            </Typography>
            <ReportDropDown
              disableUnderline
              variant="standard"
              value={reportAsType}
              onChange={handleReportAsTypeChanged}>
              <ReportMenuItem value="REFERRER">
                <Typography variant="body1">Requester</Typography>
              </ReportMenuItem>
              <ReportMenuItem value="SPECIALIST">
                <Typography variant="body1">Specialist</Typography>
              </ReportMenuItem>
              {reportFormat !== 'PDF' && (
                <ReportMenuItem value="TRIAGE">
                  <Typography variant="body1">Triage Assigner</Typography>
                </ReportMenuItem>
              )}
            </ReportDropDown>
          </Stack>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="body2" color="base.grey4" mt={3}>
            {t('Case.reports.specifyDateRange')}
          </Typography>
        </Grid>
        <Grid item xs={6} lg={3}>
          <Stack direction="row" mt={3} pl={isMobile ? 0 : 3}>
            <Box>
              <Typography variant="body2">{t('Case.reports.startDate')}</Typography>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <ReportFormDateField
                  format="YYYY-MM-DD"
                  value={startDateVal}
                  onChange={(newValue) => {
                    setStartDateVal(newValue);
                    setStartDate(newValue?.format('YYYY-MM-DD') || '');
                    setIsDownloadingReport(false);
                    setIsDateValid(isReportDateValid(newValue?.format('YYYY-MM-DD') || '', endDate || ''));
                  }}
                  maxDate={dayjs(maxStartDate)}
                />
              </LocalizationProvider>
            </Box>
          </Stack>
        </Grid>
        <Grid item xs={6} lg={3}>
          <Stack direction="row" mt={3} pl={isMobile ? 1 : 3}>
            <Box>
              <Typography variant="body2">{t('Case.reports.endDate')}</Typography>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <ReportFormDateField
                  format="YYYY-MM-DD"
                  maxDate={dayjs(currentDate())}
                  minDate={dayjs(startDate || '')}
                  value={endDateVal}
                  onChange={(newValue) => {
                    //const fieldName = 'endDate';
                    setEndDateVal(newValue);
                    setEndDate(newValue?.format('YYYY-MM-DD') || '');
                    setIsDownloadingReport(false);
                    setIsDateValid(isReportDateValid(startDate || '', newValue?.format('YYYY-MM-DD') || ''));
                  }}
                />
              </LocalizationProvider>
            </Box>
          </Stack>
        </Grid>
        {reportFormat === 'PDF' && (
          <>
            <Grid xs={12} pt={4}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={consentPhi}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                      setConsentPhi(event.target.checked)
                    }
                  />
                }
                label={t('Case.reports.consent1')}
                sx={{
                  '& .MuiTypography-root': {
                    fontSize: '0.875rem'
                  }
                }}
              />
            </Grid>
            <Grid xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={consentResponsibility}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                      setConsentResponsibility(event.target.checked)
                    }
                  />
                }
                label={t('Case.reports.consent2')}
                sx={{
                  '& .MuiTypography-root': {
                    fontSize: '0.875rem'
                  }
                }}
              />
            </Grid>
            <Grid xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={consentShared}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                      setConsentShared(event.target.checked)
                    }
                  />
                }
                label={t('Case.reports.consent3')}
                sx={{
                  '& .MuiTypography-root': {
                    fontSize: '0.875rem'
                  }
                }}
              />
            </Grid>
            <Typography variant="body1" mt={2}>
              {t('Case.reports.passwordNote')}
            </Typography>
          </>
        )}
        <Grid xs={12} lg={12} pt={4}>
          <EconsultActionButton
            variant="contained"
            color="primary"
            onClick={exportReport}
            disabled={isGenerateBtnDisabled}>
            <Typography variant="body2">{t('Case.reports.generateReport')}</Typography>
          </EconsultActionButton>
        </Grid>
        <Grid xs={12} lg={8} pt={3}>
          <Typography variant="body4" component="p">
            {t('Case.reports.note')}
          </Typography>
          <Typography variant="body4" component="p">
            {t('Case.reports.ifYouHaveAccessed')}
            <Link href="mailto:OH-OTN-Privacy@ontariohealth.ca" ml={0.5}>
              <Typography variant="body4">OH-OTN-Privacy@ontariohealth.ca</Typography>
            </Link>
            <Typography variant="body4" ml={0.5}>
              {t('Case.reports.immediately')}
            </Typography>
          </Typography>
        </Grid>
      </Grid>
    </Stack>
  );
};

export default EconsultReportsView;
